import { OptionsMenuStorybook } from "@finanedi.es/storybook"
import {
  faArrowDownToBracket,
  faFileInvoice,
} from "@fortawesome/pro-light-svg-icons"
import { AlbaranReadingFiltersDtoProps } from "api/DTOs/AlbaranReadingFiltersDto"
import { formatCurrency } from "common/utils/currency"
import { TYPES_DOCUMENTOS } from "features/Crear/pages/FormCreacionDocumento/constant"
import { EstadoRevisionActual } from "features/Documentos/components/EstadoRevisionActual/EstadoRevisionActual"
import { TFunction } from "i18next"
import { frontendDateFormat } from "utils/formatDate"

interface AlbaranesEnviadosColumnsProps {
  t: TFunction
  handleDownloadPdfAlbaran: (id: string, serie: string, t: TFunction) => void
  handleConvertirDocumento: (
    rowData: AlbaranReadingFiltersDtoProps,
    finalType: string
  ) => void
  showContacto?: boolean
}

export const ALBARANES_ENVIADOS_COLUMNS_ERP = ({
  t,
  handleDownloadPdfAlbaran,
  handleConvertirDocumento,
  showContacto = true,
}: AlbaranesEnviadosColumnsProps) => {
  const columns = [
    {
      header: t("crear.albaran.tab.headerEmisionDate"),
      field: "fechaEmision",
      key: "fechaEmision",
      body: ({ fechaEmision }: AlbaranReadingFiltersDtoProps) =>
        fechaEmision ? frontendDateFormat(new Date(fechaEmision)) : "",
      style: { width: "10%" },
      sortable: true,
      sortField: "fechaEmision",
    },
    {
      header: t("crear.albaran.tab.headerNumOrder"),
      field: "serie",
      key: "serie",
      style: { width: "15%" },
      sortable: true,
      sortField: "serie",
    },
    showContacto
      ? {
          header: t("crear.albaran.tab.headerClient"),
          key: "cliente",
          field: "Librador.RazonSocial",
          body: (rowData: AlbaranReadingFiltersDtoProps) => {
            return `${rowData.razonSocialLibrado} (${rowData.nifLibrado})`
          },
          sortable: true,
          sortField: "Librador.RazonSocial",
        }
      : {},
    {
      header: t("crear.albaran.tab.headerState"),
      field: "estadoRevisionActual",
      key: "estadoRevisionActual",
      body: ({ estadoRevisionActual }: AlbaranReadingFiltersDtoProps) => {
        return estadoRevisionActual
          ? EstadoRevisionActual(estadoRevisionActual)
          : ""
      },
      style: { width: "11%" },
      sortable: true,
      alignCol: "center",
      sortField: "estadoRevisionActual",
    },
    {
      header: t("crear.albaran.tab.headerImport"),
      field: "importe",
      key: "importe",
      bodyClassName: "!tw-text-end",
      alignCol: "right",
      style: { width: "11%" },
      body: ({ importe }: AlbaranReadingFiltersDtoProps) =>
        formatCurrency(importe),
      sortable: true,
      sortField: "importe",
    },
    {
      key: "opciones",
      style: { width: "4%" },
      className: "!tw-p-2",
      bodyClassName: "!tw-w-auto tw-flex tw-justify-end",
      alignCol: "right",
      body: (rowData: AlbaranReadingFiltersDtoProps) => {
        if (!rowData.id) return null
        return (
          <OptionsMenuStorybook
            id={rowData.id}
            items={[
              {
                title: `${t("crear.factura.tab.downloadLabel")}`,
                hasRedirect: true,
                action: () => {
                  rowData.id &&
                    handleDownloadPdfAlbaran(rowData.id, `${rowData.serie}`, t)
                },
                icon: faArrowDownToBracket,
              },
              {
                title: `${t("crear.presupuesto.tab.convertirLabel")}`,
                hasRedirect: false,
                subMenu: [
                  {
                    title: `${t("asociateDoc.invoiceLabel")}`,
                    action: () =>
                      handleConvertirDocumento(
                        rowData,
                        TYPES_DOCUMENTOS.FACTURA
                      ),
                    icon: faFileInvoice,
                  },
                ],
              },
            ]}
            position='right'
          />
        )
      },
    },
  ]
  return columns
}
